import React from "react";

import { useField, useFormikContext } from "formik";
import Select, { SelectProps } from "../components/Select";
import Error from "./FormItemError";
import FieldProps from "./FieldProps";
import Label from "../components/Label";

type FormiKSelectFieldProps = SelectProps & FieldProps;

const FormikSelectField: React.FC<FormiKSelectFieldProps> = ({
  onChange,
  ...props
}) => {
  const [field, meta] = useField(props.name);
  const context = useFormikContext();
  const showError = meta.touched && meta.error;
  const error = showError ? <Error>{meta.error}</Error> : <Error></Error>;
  const id = props.id || props.name;

  const onChangeHandler = (value: any, key: any): void => {
    context.setFieldValue(props.name, value);

    if (onChange) {
      onChange(value, key);
    }
  };

  const onBlur = (): void => {
    context.setFieldTouched(props.name);
  };

  return (
    <>
      <div>
        {props.label && (
          <Label
            htmlFor={props.id || props.name}
            className="formik-field__input-label no-select"
          >
            {props.label}
          </Label>
        )}
        <Select
          {...props}
          className={`${showError &&
            "select_border_error"} input__no-autofill-color ${props.className}`}
          id={id}
          onChange={onChangeHandler}
          onBlur={onBlur}
        >
          {props.children}
        </Select>
      </div>
      <div className="mb-16 mt-8">{error}&nbsp;</div>
    </>
  );
};

export default FormikSelectField;
